import { getRefreshToken } from '@gef-ui/redux-common/selectors/appContext';
import invariant from 'invariant';
import mergeDeepRight from "ramda/es/mergeDeepRight";
import mergeRight from "ramda/es/mergeRight";
import { setAccessToken, setRefreshToken } from '../../../auth/oauth2/actions';
import logout from '../../../auth/oauth2/logout';
import postOauthFormEncoded from '../../../auth/oauth2/postOAuthFormEncodedFacade';
import { getCode, getOauthBodyWithAuthorizationGrantType, getOauthBodyWithRefreshTokenGrantType } from '../../../auth/oauth2/selectors';
import { decodeCode, viewCode } from '../../../auth/oauth2/utils';
import { closeValve, openValve } from '../../valve';
export const obtainTokensWithBuffering = (action = {}, { beforeLogout, frontendUrl, customLogoutResolver } = {})=>async (dispatch, getState)=>{
        const state = getState();
        const body = action.accessTokenPayload ?? {};
        const refreshToken = getRefreshToken(state);
        if (!refreshToken) {
            const code = getCode(state) || viewCode(body);
            invariant(code, 'Unable to obtain oauth2 access and refresh tokens without code.');
        }
        closeValve();
        return dispatch(postOauthFormEncoded({
            endpoint: ({ urls })=>`${urls.token}`,
            body: refreshToken ? mergeDeepRight(getOauthBodyWithRefreshTokenGrantType(state), body) : decodeCode(mergeRight(getOauthBodyWithAuthorizationGrantType(state), body)),
            actions: {
                onSuccess: [
                    setAccessToken,
                    setRefreshToken
                ]
            }
        })).catch((err)=>{
            logout(action.beforeLogout ?? beforeLogout)({
                failure: err,
                frontendUrl: action.frontendUrl ?? frontendUrl,
                customLogoutResolver: action.customLogoutResolver ?? customLogoutResolver
            })(dispatch, getState);
            throw err;
        }).finally(openValve);
    };
